enum TargetingCriteriaType {
  DailyMaxAbove = 'DAILY_MAX_ABOVE',
  DestinationRain = 'DESTINATION_RAIN',
  DestinationSnow = 'DESTINATION_SNOW',
  DestinationTemperature = 'DESTINATION_TEMPERATURE',
  DestinationWeather = 'DESTINATION_WEATHER',
  Pollen = 'POLLEN',
  Temperature = 'TEMPERATURE',
  UV = 'UV',
  UvCategory = 'UV_CATEGORY',
  Weather = 'WEATHER',
}

const WEATHER_TYPES = [
  TargetingCriteriaType.DailyMaxAbove,
  TargetingCriteriaType.DestinationRain,
  TargetingCriteriaType.DestinationSnow,
  TargetingCriteriaType.DestinationTemperature,
  TargetingCriteriaType.DestinationWeather,
  TargetingCriteriaType.Pollen,
  TargetingCriteriaType.Temperature,
  TargetingCriteriaType.UV,
  TargetingCriteriaType.UvCategory,
  TargetingCriteriaType.Weather,
];
export function isWeatherCriteria(type: TargetingCriteriaType) {
  return WEATHER_TYPES.includes(type);
}

export default TargetingCriteriaType;
